<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    custom-class="el-dialog--customize"
  >
    <div class="dialog-container">
      <div class="dialog-tip">
        <i class="el-icon-warning-outline"></i>
        <span>{{ tips }}</span>
      </div>
      <div class="dialog-content ccui-multifunctional-table-wrapper">
        <el-table
          :data="tableData"
          :fit="true"
          border:min-height="427"
          class="ccui-multifunctional-table"
        >
          <el-table-column label="序号" type="index" width="55">
          </el-table-column>
          <el-table-column
            label="商品名称"
            :min-width="300"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ row.skuName }}
            </template>
          </el-table-column>
          <el-table-column
            label="店铺"
            :min-width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ row.shopName }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { checkFrozenSkuInfos } from "@/api/emc-api";
export default {
  name: "clear-goods",
  props: {},
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    title() {
      return "提示";
    },
    tips() {
      return "所选商品因价格投诉暂无法下单，请您重新选择其他商品后重试。";
    }
  },
  created() {
    // this.init();
  },
  watch: {},
  methods: {
    init() {},
    checkFrozenSkuInfos(skuIds) {
      return new Promise((resolve, reject) => {
        checkFrozenSkuInfos({ skuIds, isShowLoading: true })
          .then(res => {
            if (res.data.code == "0") {
              if (res.data.data.list.length > 0) {
                this.dialogVisible = true;
                this.tableData = res.data.data.list;
                reject();
              } else {
                resolve();
              }
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-tip {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: #4a4a4a;
  .el-icon-warning-outline {
    color: #f08d00;
    font-size: 28px;
    font-weight: 600;
  }
  span {
    vertical-align: text-bottom;
    margin-left: 10px;
  }
}
.dialog-content {
  //border: 1px solid #eaeaea;
  //padding: 16px 20px;
  margin-top: 10px;
}

/deep/.el-dialog__body {
  // min-height: 215px;
}
.dialog-footer-info {
  float: left;
  font-size: 14px;
  .selected-count {
    color: #ff142f;
    font-weight: 600;
  }
}
/deep/.el-table tr th {
  padding: 0px !important;
  background: #eeeeee;
  color: #9b9b9b;
}
/deep/.el-table tr td {
  padding-top: 0px !important;
  text-align: left !important;
}
</style>
